import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { LightPrivateBill } from "@/Patient/Api/PrivateBill/Dto/LightPrivateBill";
import { PrivateBill } from "./PrivateBill";

interface IPrivateBillSectionProps {
    bills: LightPrivateBill[];
    isEditMode: boolean;
    isReadOnly: boolean;
    isSignedOff: boolean;
}

function PrivateBillSection(props: IPrivateBillSectionProps): JSX.Element {
    const showPrivateBillEditPopup = (): void => {
        LocalEvent.Dispatch(LocalPatientOperations.MedicalNote.ShowPrivateBillEditPopup);
    };

    const showReusingBillPopup = (): void => {
        LocalEvent.Dispatch(LocalPatientOperations.MedicalNote.ShowReusingBillPopup);
    };

    return (
        <tr>
            <td className="c1 bottom-pad">
                <strong>{cacheStore.GetString("InvoiceLabel")}</strong>
            </td>
            <td className="c2">
                <div className="tb-row tb">
                    <div className="add-btn-column">
                        {(props.isSignedOff || !props.isEditMode) ? "" : <a onClick={() => showPrivateBillEditPopup()} data-cy="privateBillSection-addBill">[+]</a>}
                    </div>
                    <div className="note-items-column" data-cy="privateBillSection-billSection">
                        <>
                            <PrivateBill
                                bills={props.bills}
                            />
                        </>
                        {((!props.isSignedOff && !props.isEditMode) || props.isReadOnly) ? "" : (
                            <div>
                                <a onClick={() => showPrivateBillEditPopup()}>
                                    {cacheStore.GetString("NewBillLabel")}
                                </a>
                                <span className="margin-sm-left">|</span>
                                <a className="margin-sm-left" onClick={() => showReusingBillPopup()}>
                                    {cacheStore.GetString("ReuseABillLabel")}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </td>
        </tr>
    );
}

export { PrivateBillSection };
